import { AssetfiAssetType } from '@/types/asset-type';

export default function CheckBoxFilledSvg({ width, height }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.0664062" width="20" height="20" rx="2" fill="#357AFF" />
      <path d="M5.5 9.34277L9.33016 13.1729L16.1066 6.3965" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
